module.exports = __webpack_public_path__ + "img/ImagesMX-300EOS.2eddd116.png";